import axiosInstance from './axios';

export const warrantyService = {
  getWarranties: async (params = {}) => {
    const response = await axiosInstance.get('/warranties', { params });
    return response.data;
  },

  getWarranty: async (id) => {
    const response = await axiosInstance.get(`/warranties/${id}`);
    return response.data;
  },

  getWarrantyByUuid: async (uuid) => {
    const response = await axiosInstance.get(`/warranties/uuid/${uuid}`);
    return response.data;
  },

  extendWarranty: async (id, months) => {
    const response = await axiosInstance.post(`/warranties/${id}/extend`, { months });
    return response.data;
  },

  downloadCertificate: async (id) => {
    const response = await axiosInstance.get(`/warranties/${id}/certificate`, {
      responseType: 'blob',
    });
    const url = window.URL.createObjectURL(new Blob([response.data]));
    const link = document.createElement('a');
    link.href = url;
    link.setAttribute('download', `Certificat_Garantie_${id}.pdf`);
    document.body.appendChild(link);
    link.click();
    link.remove();
    window.URL.revokeObjectURL(url);
  },
};
